import { useMutation } from "@tanstack/react-query";
import { setCharactersFromText } from "common/api/asocijator/topic/asocijator_topic_input_way_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSetCharactersFromTextParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
};

export const useSetCharactersFromText = (
  hookParams?: UseSetCharactersFromTextParams
) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: setCharactersFromTextMutate } = useMutation({
    mutationFn: async (params: any) =>
      await setCharactersFromText({
        topicId: params.topicId,
      }),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }
    },
  });

  return { setCharactersFromTextMutate };
};
